import * as React from 'react'
import * as Debounce from 'react-debounce-input'
import './Header.scss'
import { TooltipWithIcon } from '../TooltipWithIcon'
import { Button, Icon, Alert } from 'antd'
import { BlazeButton } from '../CustomButtons/BlazeButton'
import { capitalizeFirstLetter } from '../../utilities/helpers'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import ReactMarkdown from 'react-markdown'

export interface AppHeaderProps extends React.PropsWithChildren<unknown> {
  backButtonTitle?: string | JSX.Element
  title: string
  backVisible?: boolean
  noMenuButton?: boolean
  onBackClick?: () => void
  updateTitle?: (title: string) => void
  currentCompanyStore?: CurrentCompanyStore
}

export interface State {
  expanded: boolean
  isTitleEditable: boolean
}

@inject('currentCompanyStore')
export default class AppHeader extends React.Component<AppHeaderProps, State> {
  state = {
    expanded: document.body.classList.contains('expanded'),
    isTitleEditable: false,
  }

  toggleMenu = () => {
    const body = document.body
    body.classList.contains('expanded')
      ? body.classList.remove('expanded')
      : body.classList.add('expanded')

    this.setState({
      expanded: !this.state.expanded,
    })
  }

  toggleIsTitleEditable = () => this.setState({ isTitleEditable: !this.state.isTitleEditable })

  get titleWithCapitalizedFirstLetter(): string {
    return capitalizeFirstLetter(this.props.title)
  }

  render() {
    const { isTitleEditable } = this.state
    const {
      title,
      backVisible,
      noMenuButton,
      onBackClick,
      updateTitle,
      currentCompanyStore,
      backButtonTitle,
      children,
    } = this.props

    return (
      <>
        {!!currentCompanyStore!.company!.bannerMessage && (
          <Alert
            type='error'
            banner
            className='banner-message'
            message={<ReactMarkdown source={currentCompanyStore!.company!.bannerMessage} />}
          />
        )}
        <div className='app-header'>
          <div className='app-header__left'>
            <div id='expand-button' className={`${noMenuButton ? 'd-none' : 'd-flex d-md-none'}`}>
              <Icon
                type={this.state.expanded ? 'close' : 'menu'}
                onClick={this.toggleMenu}
                style={{ fontSize: '20px' }}
              />
            </div>
            {backVisible && onBackClick && (
              <BlazeButton
                buttonProps={{
                  icon: 'arrow-left',
                  className: 'app-header__back',
                  onClick: onBackClick,
                }}
                titleProps={{
                  title: backButtonTitle || 'Back',
                }}
              />
            )}

            {isTitleEditable && updateTitle ? (
              <Debounce
                className='form-control audit__title'
                value={title}
                debounceTimeout={500}
                onBlur={this.toggleIsTitleEditable}
                onChange={(e: any) => updateTitle(e.target.value)}
              />
            ) : (
              <h1 className='app-header__title'>{this.titleWithCapitalizedFirstLetter}</h1>
            )}
            {updateTitle && (
              <span onClick={this.toggleIsTitleEditable}>
                <TooltipWithIcon
                  place='bottom'
                  tooltipIconClassName='app-header__pencil text-muted fa fa-pencil ml-2'
                  tooltipContent={<span>Click to edit the audit title</span>}
                />
              </span>
            )}
          </div>
          <div className='app-header__content'>{children}</div>
        </div>
      </>
    )
  }
}

export class AppSubtitle extends React.Component<AppHeaderProps, any> {
  render() {
    return (
      <div className='app-subtitle'>
        <h1 className='app-subtitle__title'>{this.props.title}</h1>
        <div className='app-subtitle__content'>{this.props.children}</div>
      </div>
    )
  }
}
